import { getI18nFromGeneral } from 'src/tools/tools';
import { handleError } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { get } from 'lodash';

const generateTopLeaderBoardBanner = () => {
  return {
    topLeaderBoardBanner: {
      linkModule: {
        label: 'None',
        linkType: 'None',
      },
    },
  };
};
const generateMenu = () => {
  return { menu: { enabled: false, roots: [] } };
};
const generateProductGridSetting = () => {
  return {
    gridSetting: {
      buttonThemeUuid: null,
    },
  };
};

const checkRoots = (data) => {
  const enabled = get(data, 'enabled');
  const roots = get(data, 'roots') || [];
  if (roots.length < 1 && enabled) {
    return handleError([
      getI18nFromGeneral(`general.moduleListError.${999992}`),
    ]);
  }
};

const checkAll = (data) => {
  const menu = get(data, 'menu');
  return checkRoots(menu);
};

export {
  checkRoots,
  generateTopLeaderBoardBanner,
  generateMenu,
  generateProductGridSetting,
  checkAll,
};
